import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { convertBase64ToHtmlImage } from '../util/convert-base64-to-html-image.util';
import { from, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const imageMaxSizeValidator = ({ maxWidth, maxHeight }: { maxWidth: number; maxHeight: number }): AsyncValidatorFn => {
  return (control: AbstractControl) => {
    let convertImageObservable: Observable<HTMLImageElement> | null = null;

    if (control.value instanceof File) {
      const imageUrl = URL.createObjectURL(control.value);
      convertImageObservable = from(convertBase64ToHtmlImage(imageUrl));
    } else if (typeof control.value === 'string' && control.value.startsWith('data:image')) {
      convertImageObservable = from(convertBase64ToHtmlImage(control.value));
    } else {
      return of(null);
    }

    return convertImageObservable.pipe(
      take(1),
      map(image => {
        const isImageSizeInvalid = image.width > maxWidth || image.height > maxHeight;
        return isImageSizeInvalid ? { invalidImageSize: true } : null;
      })
    );
  };
};
